import { createReducer } from '@reduxjs/toolkit';
import { RouterShape, Page } from './model';
import * as routerActions from './actions';

const initial: RouterShape = {
  page: null,
};

export const routerReducer = createReducer<RouterShape>(initial, (builder) =>
  builder.addCase(routerActions.pagePathChanged, (s, a) => {
    s.page = a.payload.page as Page;
  }),
);
